import React from 'react';
import Stack from '@mui/material/Stack';
import WelcomeMessageEditor from './components/WelcomeMessageEditor';
import FailureMessageEditor from './components/FailureMessageEditor';
import type { IClinic } from '@app/interfaces/clinic.interface';
import SuccessMessageEditor from '@app/pages/clinicPage/components/settingBlockMessageTab/components/SuccessMessageEditor';
import SuccessFeedbackMessageEditor from '@app/pages/clinicPage/components/settingBlockMessageTab/components/SuccessFeedbackMessageEditor';
import { ImageField } from '@widgets/image-field';

interface Props {
  clinic: IClinic;
  setClinic: (clinic: IClinic) => void;
}

function SettingBlockMessageTab({ clinic, setClinic }: Props) {
  return (
    <Stack spacing={2}>
      <ImageField field='fbWelcomeImageUrl' clinic={clinic} />

      <WelcomeMessageEditor clinic={clinic} setClinic={setClinic} />

      <ImageField field='fbFeedbackImageUrl' clinic={clinic} />

      <SuccessFeedbackMessageEditor clinic={clinic} setClinic={setClinic} />

      <SuccessMessageEditor clinic={clinic} setClinic={setClinic} />

      <FailureMessageEditor clinic={clinic} setClinic={setClinic} />
    </Stack>
  );
}

export default SettingBlockMessageTab;
